export default __webpack_public_path__ + "static/media/str-chat__connection-error.90385cff.svg";